import { Component, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { InventoryService } from '../../services/inventory/inventory.service';

@Component({
  selector: 'app-inventory-output',
  templateUrl: './inventory-output.component.html',
  styleUrls: ['./inventory-output.component.scss']
})
export class InventoryOutputComponent implements OnChanges {
  @Input() inventoryProducts: any[] = [];
  @Input() loading: boolean = false;
  @Input() error: string = '';
  @Input() orderItemId: string = '';
  @Output() output = new EventEmitter<{ productId: string, quantity: number, orderItemId: string }>();
  @Output() delete = new EventEmitter<{ productId: string, orderItemId: string }>();
  private previousProductId: string = '';

  selectedProductId: string = undefined;
  quantity: number = 1;

  // Add groupBy function for ng-select
  groupByFirstWord = (item: any) => (item.name?.split(' ')[0] || '');

  constructor(private inventoryService: InventoryService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.orderItemId && this.orderItemId) {
      // Reset the form when order item changes
      this.selectedProductId = undefined;
      this.quantity = 1;
      this.previousProductId = '';
    }
  }

  get currentInventoryNumber(): string | number {
    if (!this.selectedProductId || !this.inventoryProducts) return 'N/A';
    const product = this.inventoryProducts.find(p => p.id === this.selectedProductId);
    return product && product.currentNumber !== undefined ? product.currentNumber : 'N/A';
  }

  emitOutput() {
    if (!this.selectedProductId) {
      if (this.previousProductId) {
        console.log('Emitting delete', this.previousProductId, this.orderItemId);
        this.delete.emit({ productId: this.previousProductId, orderItemId: this.orderItemId });
        this.previousProductId = '';
      }
      return;
    }
    if (!this.quantity) return;
    this.output.emit({ productId: this.selectedProductId, quantity: this.quantity, orderItemId: this.orderItemId });
    this.previousProductId = this.selectedProductId;
  }
} 
